import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconTools from '@/icons/Tools.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingRepairNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_repair'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const workshopName = notification.data.onBehalfOfWorkshop?.name;

  return (
    <BaseNotification
      notificationLabel={
        notification.data.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-repair.label.on-behalf',
              message: `Pending repair for request ${requestReference} on behalf of ${workshopName}`,
            })
          : t({
              id: 'notification.pending-repair.label',
              message: `Pending repair for request ${requestReference}`,
            })
      }
      icon={<IconTools />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-repair.on-behalf">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            may notify the workshop{' '}
            <InlineText weight="medium" color={color}>
              {workshopName}
            </InlineText>{' '}
            that the repair can now begin.
          </Trans>
        ) : (
          <Trans id="notification.pending-repair">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new repair to do
          </Trans>
        )
      }
    />
  );
};
